"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CaretUpFill = {
  name: 'caret-up',
  theme: 'fill',
  nameWithTheme: 'caret-up-fill',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M76.3 632.8l405.1-489.1c16.9-18.9 46.5-18.9 63.4 0l403.1 489.1c24.4 27.4 5 70.8-31.7 70.8H107.9c-36.6 0-56.1-43.4-31.6-70.8z'
    },
    children: []
  }]
};
exports.default = CaretUpFill;